let heroSlider;
const initHeroSlider = () => {
  heroSlider = new Swiper('[data-hero-slider]', {
    loop: true,
    effect: "fade",
    slidesPerView: 1,
    spaceBetween: 0,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false
    // },
    navigation: {
      prevEl: ".hero-slider__button.prev",
      nextEl: ".hero-slider__button.next",
    },
    pagination: {
      el: ".hero-slider__pagination",
      clickable: true
    },
  });
};  

window.addEventListener('DOMContentLoaded', initHeroSlider);